// Import JSON content
import navigationData from "./common/navigation.json"
import footerData from "./common/footer.json"
import siteMetadata from "./common/site-metadata.json"
import homePageData from "./pages/home.json"
import aboutPageData from "./pages/about.json"
import agentsToolingPageData from "./pages/agents-tooling.json"
import trainingPageData from "./pages/training.json"
import processPageData from "./pages/process.json"
import pharmaceuticalPageData from "./pages/industries/pharmaceutical.json"
import commercialRealEstatePageData from "./pages/industries/commercial-real-estate.json"
import compliancePageData from "./pages/industries/compliance.json"

// Import types
import type {
  Navigation,
  Footer,
  HeroSection,
  ServicesSection,
  ContactSection,
  ProcessPage,
  IndustryPageContent,
} from "@/types/content"

// Export common content
export const navigation: Navigation = navigationData
export const footer: Footer = footerData
export { siteMetadata }

// Export page content with proper type assertions
export const homePage = {
  ...homePageData,
  hero: homePageData.hero as HeroSection,
  services: homePageData.services as ServicesSection,
  contact: homePageData.contact as ContactSection,
}
export const aboutPage = aboutPageData
export const agentsToolingPage = agentsToolingPageData
export const trainingPage = trainingPageData
export const processPage: ProcessPage = processPageData as ProcessPage

// Export industry pages
export const pharmaceuticalPage: IndustryPageContent = pharmaceuticalPageData as IndustryPageContent
export const commercialRealEstatePage: IndustryPageContent = commercialRealEstatePageData as IndustryPageContent
export const compliancePage: IndustryPageContent = compliancePageData as IndustryPageContent

// Utility function to get all homepage sections in array format (for backward compatibility)
export const getHomePageSections = () => [homePage.hero, homePage.services, homePage.about, homePage.contact]

// Future-ready content loader that could be extended for CMS integration
export class ContentLoader {
  static async getNavigation(): Promise<Navigation> {
    // Currently returns static data, but could be extended to fetch from CMS
    return navigation
  }

  static async getFooter(): Promise<Footer> {
    return footer
  }

  static async getHomePage() {
    return homePage
  }

  static async getAboutPage() {
    return aboutPage
  }

  static async getAgentsToolingPage() {
    return agentsToolingPage
  }

  static async getTrainingPage() {
    return trainingPage
  }

  static async getProcessPage() {
    return processPage
  }

  static async getPharmaceuticalPage() {
    return pharmaceuticalPage
  }

  static async getCommercialRealEstatePage() {
    return commercialRealEstatePage
  }

  static async getCompliancePage() {
    return compliancePage
  }

  static async getSiteMetadata() {
    return siteMetadata
  }
}

// Direct exports for easy access
export { default as navigationData } from "./common/navigation.json"
export { default as footerData } from "./common/footer.json"
export { default as siteMetadataData } from "./common/site-metadata.json"
export { default as homePageData } from "./pages/home.json"
export { default as aboutPageData } from "./pages/about.json"
export { default as agentsToolingPageData } from "./pages/agents-tooling.json"
export { default as trainingPageData } from "./pages/training.json"
export { default as processPageData } from "./pages/process.json"
export { default as pharmaceuticalPageData } from "./pages/industries/pharmaceutical.json"
export { default as commercialRealEstatePageData } from "./pages/industries/commercial-real-estate.json"
export { default as compliancePageData } from "./pages/industries/compliance.json"
